import {Component, Inject} from '@angular/core';
import {faClone, faLink, faShareAlt} from "@fortawesome/free-solid-svg-icons";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {TrvGlobalMessagesService, TrvTooltipDirective, TrvTooltipPosition} from "@trv-hub/trv-ng-common";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {TrvNgMapService} from "@trafikverket/trv-ng-map";
import {join} from "@angular/compiler-cli";
import {NvdbNavigationService} from "@app/service/nvdb-navigation.service";
import { LanguageService } from '@app/service/language.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-share-map-section',
    imports: [
        FaIconComponent,
        TrvTooltipDirective,
        ReactiveFormsModule
    ],
    templateUrl: './share-map-section.component.html',
    styleUrl: './share-map-section.component.scss'
})
export class ShareMapSectionComponent {
    public toolTipPositions: TrvTooltipPosition[] = ["bottom", "right"];

    protected readonly faShareAlt = faShareAlt;

    constructor(private globalMessagesService: TrvGlobalMessagesService,
                public nvdbNavigationService: NvdbNavigationService,
                @Inject(TrvNgMapService) public trvMapService: TrvNgMapService,
                public lang: LanguageService,
    ) {
    }

    // example url: /map?east=527764&north=6707199&scale=1000&backgroundLayer=Ortofoto_0.5&wmslayers=Trafiksakerhetsklass_passage_GCM
    async shareMap() {
        let url = `${location.origin}/map?`
        if (this.nvdbNavigationService.shareMapState.includeBackgroundLayer.value == true) {
            url += `&backgroundLayer=${this.trvMapService.trvMap?.trvLayer?.currentBackroundLayer?.id}`
        }
        if (this.nvdbNavigationService.shareMapState.includeWmsLayers.value == true) {
            url += `&wmslayers=${this.trvMapService.trvMap?.trvLayer?.getVisibleWmsLayer().map(a => a.id).join("|")}`
        }

        var centerCoord = this.trvMapService.trvMap?.map.getView().getCenter()!;
        var scale = this.trvMapService.trvMap!.getScaleForResolution()
        url += `&east=${centerCoord[0]}&north=${centerCoord[1]}&scale=${scale}`
        if (environment.application === "JNBKarta") {
            url += `&year=${this.nvdbNavigationService.searchMenuState.yearObject.value?.displayYear}`
        }


        await navigator.clipboard.writeText(url)
        this.globalMessagesService.success(this.lang.GetValue("ShareMap.Copied"))
    }

    protected readonly faLink = faLink;
    protected readonly faClone = faClone;
}
